export const GET_COMPLETED_MERCHANT_SERVICES = gql`
    query GetCompletedServices {
        completedServices {
            id
            serviceNumber
            dateActivated
            merchantAccountNumber
            status
            merchantName
            serviceType
            applicationId
            merchantId
        }
    }
`;

export const GET_IN_PROGRESS_MERCHANT_SERVICES = gql`
    query GetInProgressServices {
        inProgressServices {
            id
            serviceNumber
            dateActivated
            merchantAccountNumber
            status
            merchantName
            serviceType
            applicationId
            merchantId
        }
    }
`;

export const GET_SERVICE_TRIAL_STATUS = gql`
    query GetServiceTrialStatus($serviceId: Int!) {
        serviceTrialStatus(serviceId: $serviceId) {
            onTrial
            trialEndDate
        }
    }
`;

export const GET_SERVICE_PROMOTION_STATUS = gql`
    query GetServicePromotionStatus($serviceId: Int!) {
        servicePromotionStatus(serviceId: $serviceId) {
            onPromo
            promoType
            promoExpiryDate
        }
    }
`;
